import $ from 'jquery';
import { handleContainerDevMessages } from './mpro.error-handling';

/**
 * @param {JQuery} $container
 */
mpro.showDevMessages = function($container) {
	handleContainerDevMessages($container);
};

/**
 * @param {JQuery} $container
 */
mpro.showFlashMessages = function($container) {

	const $jsonCont = $container.find('script[data-flash-messages]').remove();

	if ($jsonCont.length === 0) {
		return;
	}

	try {
		const messages = JSON.parse($jsonCont.text());
		const {
			/** @type {string[]} */ success,
			/** @type {string[]} */ notice,
			/** @type {string[]} */ warning,
			/** @type {string[]} */ error,
		} = messages;

		// Show success toasts
		if (success && success.length > 0) {
			mpro.toast('success', success.join('<br>'));
		}

		// Show info toasts
		if (notice && notice.length > 0) {
			mpro.toast('info', notice.join('<br>'));
		}

		// Show warning toasts
		if (warning && warning.length > 0) {
			mpro.toast('warning', warning.join('<br>'));
		}

		// Show error toasts
		if (error && error.length > 0) {
			mpro.toast('error', error.join('<br>'));
		}
	}
	catch (error) {
		console.warn('Invalid JSON in flash-messages container', error, $jsonCont);
	}
};

/**
 * @param {JQuery} $container
 */
mpro.handleAlertContainer = function($container) {

	const $dCont = $container.find(mpro.config.ui.alert.container_dismissible_selector);

	if ($dCont.length > 0) {

		if ($dCont.children().length === 0) {
			$dCont.remove();
			return;
		}

		$dCont.find('.alert').on('closed.bs.alert', () => {
			if ($dCont.children().length === 0) {
				$dCont.remove();
			}
		});
	}
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {
	mpro.showDevMessages($container);
	mpro.showFlashMessages($container);
	mpro.handleAlertContainer($container);
});

export default mpro;
